import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum OrderVariantErrorType {
  MAX_QUANTITY = "max_quantity",
  OVER_BUDGET = "over_budget",
  OTHER = "other",
}

export type TOrderVariantError = {
  error: string;
  maxQuantity?: number | null;
  type: OrderVariantErrorType;
};

type TOrderSetState = {
  isOrdering: boolean;
  clearAllErrors: boolean;
  orderVariantErrors: Record<string | number, TOrderVariantError>;
};

const initialState: TOrderSetState = {
  isOrdering: false,
  clearAllErrors: false,
  orderVariantErrors: {},
};

const orderSetSlice = createSlice({
  name: "orderSet",
  initialState,
  reducers: {
    setIsOrdering(state, action: PayloadAction<{ status: boolean }>) {
      const { status } = action.payload;
      state.isOrdering = status;
    },
    setClearAllErrors(state, action: PayloadAction<boolean>) {
      state.clearAllErrors = action.payload;
      if (!action.payload) {
        state.orderVariantErrors = {};
      }
    },
    setOrderVariantError(
      state,
      action: PayloadAction<
        {
          id: string | number;
        } & TOrderVariantError
      >
    ) {
      const { id, ...error } = action.payload;
      state.orderVariantErrors[id] = error;
    },
    removeOrderVariantError(
      state,
      action: PayloadAction<{ id: string | number }>
    ) {
      const { id } = action.payload;
      delete state.orderVariantErrors[id];
    },
    clearOrderVariantErrors(state) {
      state.orderVariantErrors = {};
    },
  },
});

export const {
  setIsOrdering,
  setOrderVariantError,
  removeOrderVariantError,
  clearOrderVariantErrors,
  setClearAllErrors,
} = orderSetSlice.actions;

export default orderSetSlice.reducer;
